export default {
  submissions(state) {
    return state.submissions
  },
}
